import React, { Suspense } from 'react';
import Spline from '@splinetool/react-spline';

const Spline3D = () => {
  return (
    <div
      className="relative"
      style={{
        width: '700px',
        height: '700px',
        overflow: 'visible',
        position: 'relative',
      }}
    >
      <Suspense
        fallback={
          <div
            className="w-full h-full flex items-center justify-center"
            style={{
              background: 'linear-gradient(135deg, #8B5CF6, #0EA5FF)',
              borderRadius: '20px',
              boxShadow: '0 0 80px rgba(14, 165, 255, 0.6)',
            }}
          >
            <div className="text-center">
              <div className="animate-spin w-16 h-16 border-4 border-white border-t-transparent rounded-full mx-auto"></div>
              <p className="mt-4 text-white text-lg">Loading 3D Scene...</p>
            </div>
          </div>
        }
      >
        <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
      </Suspense>
    </div>
  );
};

export default Spline3D;